import { discountType } from '@/utils/enums'

export default {
  initTax: {
    flower: 0.0,
    shake_trim: 0.0,
    plant: 0.0,
    edibles: 0.0,
    tincture: 0.0,
    topical: 0.0,
    trans_dermal: 0.0,
    extract: 0.0,
    concentrate: 0.0,
    capsule: 0.0,
    pre_roll: 0.0,
    combined_category: 0.0,
    suppository: 0.0,
    waste: 0.0,
    ancillary: 0.0,
    other: 0.0
  },
  taxes: [],
  loading: false,
  TaxType: 'Excise Tax',
  stock_photos: [],
  total: 0,
  FilteredCount: 0,
  FilteredCountSystemDiscount: 0,
  totalSystemDiscount: 0,
  FilteredCountUserDiscount: 0,
  totalUserDiscount: 0,
  rewardSetup: {},
  spfRecords: [],
  systemDiscountAndTax: [
    { id: 1, name: 'Veteran', value: 0, city_tax: false, state_tax: true, county_tax: false, type: 'system', discount_type: discountType.percentage },
    { id: 2, name: 'Veteran (Disabled)', value: 0, city_tax: false, state_tax: true, county_tax: false, type: 'system', discount_type: discountType.percentage },
    { id: 3, name: 'Govt. Employee', value: 0, city_tax: false, state_tax: true, county_tax: false, type: 'system', discount_type: discountType.percentage },
    { id: 4, name: 'Other', value: 0, city_tax: false, state_tax: true, county_tax: false, type: 'system', discount_type: discountType.percentage }
  ],
  userDiscount: {},
  userDiscountAndTax: [],
  tieredPricingList: []
}
